export default async function Http(input: RequestInfo, init?: RequestInit) {
    const response = await fetch(input, init);
    if (response.status === 200 || response.status === 304) {
        return response;
    } else {
        return Promise.reject(response);
    }
}